import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faTwitterSquare, faLinkedinIn, faGithubSquare } from '@fortawesome/free-brands-svg-icons';
import { faSyncAlt, faBackspace, faCalculator, faPlus, faMinus, faTimes,
  faDivide, faEquals, faDollarSign, faChartLine } from '@fortawesome/free-solid-svg-icons';

library.add(
  faFacebook, faTwitterSquare, faLinkedinIn, faGithubSquare,
  faSyncAlt, faBackspace, faCalculator, faPlus, faMinus,
  faTimes, faDivide, faEquals, faDollarSign, faChartLine
);